import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import { workQueueActions } from 'store/slices/workQueueSlice';
import { listRelayQueueByPage, updateRelayQueueSort } from 'store/thunks/workQueueThunks';

import RelayOrdersTableView from './RelayOrdersTableView';

/**
 * POM-6099 — relayed orders (Diamond via Quello), POM sys-admin only: the Central Fill queue's
 * Relay tab. Since POM-6279 this is the REDUX CONTAINER only -- it owns the relayQueue paging and
 * the fetch -- and the table itself, with the column set and the reasoning behind every column
 * that is and is not there, lives in RelayOrdersTableView, which the patient page's Relay Orders
 * tab shares.
 */
const RelayOrdersTable = ({ onOpenDetails }) => {
  const dispatch = useDispatch();
  const currentPage = useSelector(({ workQueue }) => workQueue.relayQueue.currentPage);
  const count = useSelector(({ workQueue }) => workQueue.relayQueue.count);
  const relayOrders = useSelector(({ workQueue }) => workQueue.relayQueue.pages[currentPage]);
  const sortBy = useSelector(({ workQueue }) => workQueue.relayQueue.sortBy);

  useEffect(() => {
    dispatch(listRelayQueueByPage({ page: currentPage }));
  }, [dispatch, currentPage]);

  // Only moves the page. The effect above owns the fetch, so dispatching the list thunk here
  // too would fetch twice per click -- the thunk sets currentPage, which re-runs the effect --
  // and each round trip carries a page of orders.
  const handlePageChange = useCallback(
    (page) => dispatch(workQueueActions.updateCurrentPage({ preset: 'relayQueue', page })),
    [dispatch]
  );

  const handleSortChange = useCallback(
    (nextSortBy) => dispatch(updateRelayQueueSort({ sortBy: nextSortBy })),
    [dispatch]
  );

  return (
    <RelayOrdersTableView
      rows={relayOrders}
      count={count}
      page={currentPage}
      onPageChange={handlePageChange}
      onOpenDetails={onOpenDetails}
      sortBy={sortBy}
      onSortChange={handleSortChange}
    />
  );
};

RelayOrdersTable.propTypes = {
  onOpenDetails: PropTypes.func.isRequired,
};

export default RelayOrdersTable;
